import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PublicApi } from "../api/services";
import { kmBetween } from "../lib/format";

type P = { lat: number; lng: number } | null | undefined;

// Uses the server routing service when configured; otherwise a clearly-labelled straight line.
export function useRoute(from: P, to: P) {
  const r4 = (n?: number) => (n == null ? n : Math.round(n * 1000) / 1000);
  const { data } = useQuery({
    queryKey: ["route", r4(from?.lat), r4(from?.lng), r4(to?.lat), r4(to?.lng)],
    queryFn: () => PublicApi.route(from, to),
    enabled: !!from && !!to,
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
  });
  if (!from || !to) return { route: undefined, routed: false, durationS: undefined as number | undefined };
  if (data?.available) return { route: data.coordinates as [number, number][], routed: true, durationS: data.duration_s as number };
  const km = kmBetween(from, to);
  return { route: [[from.lat, from.lng], [to.lat, to.lng]] as [number, number][], routed: false, noRouting: data?.available === false, durationS: km != null ? (km * 1.3 / 30) * 3600 : undefined };
}
